import { c } from "./colors";
import { Frame, type IllustrationProps } from "./Frame";

export function TeamIllustration(props: IllustrationProps) {
  return (
    <Frame {...props}>
      <circle cx="38" cy="72" r="12" fill={c.p300} />
      <path d="M16 120c0-15 10-26 22-26s22 11 22 26z" fill={c.p300} />
      <circle cx="122" cy="72" r="12" fill={c.a300} />
      <path d="M100 120c0-15 10-26 22-26s22 11 22 26z" fill={c.a300} />
      <circle cx="80" cy="64" r="15" fill={c.p500} />
      <path d="M52 120c0-20 12-34 28-34s28 14 28 34z" fill={c.p500} />
    </Frame>
  );
}
